import { BaseError } from './base.error';

export class UnknownError extends BaseError {
  constructor({
    context,
    message = 'An unknown error occurred',
  }: {
    context?: Record<string, unknown>;
    message?: string;
  }) {
    super(message, context);
    this.name = 'UnknownError';
  }
}
